module.exports = __webpack_public_path__ + "matin.ed564139e1c9234205a7ff8fabb7f623.png";